module.exports = __webpack_public_path__ + "img/carbon@2x.6c93c7c.webp";